type InputSearchType = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  name?: string;
}

const InputSearch = ({value, name, onChange, placeholder}: InputSearchType) => {
  return (
    <div className="tw-flex tw-items-center tw-h-full tw-justify-center tw-rounded-full tw-border-[1px] tw-border-dark-green tw-overflow-hidden tw-w-full tw-bg-white">
      <div className="tw-relative tw-w-full tw-text-gray-600 focus-within:tw-text-gray-400">
          <span className="tw-absolute tw-inset-y-0 tw-right-1 tw-flex tw-items-center tw-pl-2">
            <div className="tw-p-1 focus:tw-outline-none focus:tw-shadow-outline">
              <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" className="tw-w-6 tw-h-6"><path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
            </div>
          </span>
          <input 
            type="search" 
            name={name}
            className="tw-py-2 tw-pl-3 tw-text-sm tw-w-full tw-text-black  tw-rounded-md tw-pr-9 focus:tw-outline-none focus:tw-ext-gray-900" 
            placeholder={placeholder ? placeholder : "Search items..."} 
            autoComplete="new-password"
            value={value}
            onChange={onChange} 
          />
        </div>
    </div>
  )
}

export default InputSearch;